import { useState } from "react";
import { useTranslation } from "react-i18next";
import usePagedList from "../hooks/usePagedList";
import WorkflowEditor from "./WorkflowEditor";
import "./AdminCollections.css";

/** Workflows (Agentic Studio S4): the library of workflow graphs; open one in the canvas editor. */
export default function WorkflowsTab({ database }) {
  const { t } = useTranslation();
  const [editing, setEditing] = useState(null);       // null | "new" | workflow
  const { items, loading, error, hasMore, loadMore, reload } = usePagedList(editing ? null : "/api/v1/workflows?scope=all");

  if (editing) {
    return <WorkflowEditor database={database} workflow={editing === "new" ? null : editing}
                           onDone={() => { setEditing(null); reload(); }} />;
  }
  return (
    <div className="ds-page">
      <header className="ds-page-header">
        <h2 className="ds-page-title">{t("workflows.title")}</h2>
        <p className="ds-page-subtitle">{t("workflows.subtitle")}</p>
      </header>
      {error && <div className="ds-alert ds-alert--danger" role="alert">{error}</div>}
      <div className="ac-actions">
        <button type="button" className="ds-btn ds-btn--primary" onClick={() => setEditing("new")}>{t("workflows.new")}</button>
      </div>
      {!loading && items.length === 0 ? <div className="ds-empty">{t("workflows.empty")}</div> : (
        <ul className="ds-list">
          {items.map((w) => (
            <li key={w.id} className="ds-list-row">
              <span className="ds-list-title">{w.name}</span>
              <span className="ds-meta">{t("agents.version", { version: w.version })} · {w.owner_email}</span>
              {w.description && <span className="ds-help">{w.description}</span>}
              {w.can_edit && (
                <button type="button" className="ds-btn ds-btn--secondary ds-btn--sm" onClick={() => setEditing(w)}>
                  {t("workflows.open")}
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
      {hasMore && (
        <button type="button" className="ds-btn ds-btn--secondary ac-load-more" disabled={loading} onClick={loadMore}>
          {t("agents.loadMore")}
        </button>
      )}
    </div>
  );
}
